import {
  SPARTACUS_ACTIVE_SUPPLIER_BUCKET_VALUES,
  SPARTACUS_CHANNEL_VALUES,
  SPARTACUS_ORDER_TREND_VALUES,
  SPARTACUS_PLAN_VALUES,
  SPARTACUS_PRESET_IDS,
} from 'src/constants/spartacusFilters'

export const EMPTY_SPARTACUS_FILTER_FORM = {
  preset: undefined,
  search: '',
  plan: undefined,
  channel: undefined,
  paidPlan: undefined,
  ordersInPeriodMin: undefined,
  activeSupplierBuckets: undefined,
  xeroConnected: undefined,
  gpUsing: undefined,
  hasLastSeen: undefined,
  hasParLevels: undefined,
  hasRecipes: undefined,
  hasStockTakes: undefined,
  hasSpecialPurchases: undefined,
  hasRestrictedSuppliers: undefined,
  hasFeatureUsage: undefined,
  orderTrend: undefined,
  upgradeScoreMin: undefined,
  upgradeScoreMax: undefined,
  riskScoreMin: undefined,
  riskScoreMax: undefined,
}

const BOOLEAN_FILTER_KEYS = [
  'paidPlan',
  'xeroConnected',
  'gpUsing',
  'hasLastSeen',
  'hasParLevels',
  'hasRecipes',
  'hasStockTakes',
  'hasSpecialPurchases',
  'hasRestrictedSuppliers',
  'hasFeatureUsage',
]

const NUMERIC_FILTER_KEYS = [
  'ordersInPeriodMin',
  'upgradeScoreMin',
  'upgradeScoreMax',
  'riskScoreMin',
  'riskScoreMax',
]

function isDefined(value) {
  return value !== undefined && value !== null && value !== ''
}

export function sanitizeSpartacusFilters(filters = {}) {
  const sanitized = {}

  Object.entries(filters).forEach(([key, value]) => {
    if (!isDefined(value)) {
      return
    }

    if (key === 'search' && typeof value === 'string') {
      const trimmed = value.trim()
      if (trimmed) {
        sanitized.search = trimmed
      }
      return
    }

    if (BOOLEAN_FILTER_KEYS.includes(key) && typeof value === 'boolean') {
      sanitized[key] = value
      return
    }

    if (NUMERIC_FILTER_KEYS.includes(key)) {
      const numeric = Number(value)
      if (Number.isFinite(numeric)) {
        sanitized[key] = numeric
      }
      return
    }

    if (key === 'plan' && SPARTACUS_PLAN_VALUES.includes(value)) {
      sanitized.plan = value
      return
    }

    if (key === 'channel' && SPARTACUS_CHANNEL_VALUES.includes(value)) {
      sanitized.channel = value
      return
    }

    if (key === 'orderTrend' && SPARTACUS_ORDER_TREND_VALUES.includes(value)) {
      sanitized.orderTrend = value
      return
    }

    if (key === 'preset' && SPARTACUS_PRESET_IDS.includes(value)) {
      sanitized.preset = value
      return
    }

    if (key === 'activeSupplierBuckets' && Array.isArray(value)) {
      const buckets = [
        ...new Set(
          value.filter(bucket =>
            SPARTACUS_ACTIVE_SUPPLIER_BUCKET_VALUES.includes(bucket),
          ),
        ),
      ]

      if (buckets.length > 0) {
        sanitized.activeSupplierBuckets = buckets
      }
    }
  })

  return sanitized
}

export function formStateToApiFilters(form = EMPTY_SPARTACUS_FILTER_FORM) {
  return sanitizeSpartacusFilters(form)
}

export function filtersToFormState(filters = {}) {
  return {
    ...EMPTY_SPARTACUS_FILTER_FORM,
    ...filters,
    search: filters.search || '',
  }
}

export function hasActiveSpartacusFilters(filters = {}) {
  return Object.keys(sanitizeSpartacusFilters(filters)).length > 0
}

export function applyPresetToFilters(presetId) {
  if (!presetId) {
    return {}
  }

  return { preset: presetId }
}

export function buildFormStateFromActiveFilters(filters = {}, presets = []) {
  const presetId = filters.preset

  if (!presetId) {
    return filtersToFormState(filters)
  }

  const preset = presets.find(item => item.id === presetId)
  const explicitFilters = { ...filters }
  delete explicitFilters.preset

  return filtersToFormState({
    ...EMPTY_SPARTACUS_FILTER_FORM,
    ...(preset?.filters || {}),
    ...explicitFilters,
    preset: presetId,
  })
}

export function getPresetSelectionFromFilters(filters = {}) {
  return filters.preset || undefined
}

export function clearPresetFromFilters(filters = {}) {
  const rest = { ...filters }
  delete rest.preset
  return sanitizeSpartacusFilters(rest)
}
